<template>
  <div class="videoTutorialPage">
    <!-- 面包屑导航 -->
    <div class="breadcrumbBar">
      <div class="breadcrumbContent">
        <span class="breadcrumbLink" @click="goBack">{{ $t('menu.service') }}</span>
        <span class="breadcrumbSeparator">></span>
        <span class="breadcrumbCurrent">{{ $t('Service.videoTitle') }}</span>
      </div>
    </div>

    <div class="videoContainer">
      <!-- 搜索框 -->
      <div class="searchBox">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入您想搜索的视频"
          prefix-icon="el-icon-search"
          clearable
          @input="handleSearch"
        ></el-input>
      </div>

      <div class="mainContent">
        <!-- 左侧分类导航 -->
        <div class="categoryNav">
          <el-tree
            ref="categoryTree"
            :data="categoryTreeData"
            :props="treeProps"
            node-key="id"
            :default-expanded-keys="defaultExpandedKeys"
            :current-node-key="currentNodeKey"
            :highlight-current="true"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
          >
            <template #default="{ node, data }">
              <span class="custom-tree-node">
                <span class="node-label">{{ language === 'en' && data.fullNameEn ? data.fullNameEn : data.fullName }}</span>
              </span>
            </template>
          </el-tree>
        </div>

        <!-- 右侧视频列表 -->
        <div class="videoListWrapper">
          <div class="videoGrid" v-loading="loading">
            <div
              class="videoCard"
              v-for="(video, index) in allVideoList"
              :key="index"
              @click="playVideo(video)"
            >
              <video
                v-if="video.url && !video.thumb"
                :src="video.url"
                alt=""
                class="videoThumb"
              />
              <img
                v-else-if="video.thumb"
                :src="video.thumb"
                alt=""
                class="videoThumb"
              />
              <div v-else class="videoThumb videoThumbEmpty">
                <i class="el-icon-video-camera"></i>
              </div>
              <div class="videoInfo">
                <div class="videoTitle">{{ video.title }}</div>
              </div>
            </div>
          </div>

          <!-- 空状态 -->
          <div class="emptyState" v-if="allVideoList.length === 0 && !loading">
            <i class="el-icon-video-camera"></i>
            <p>暂无相关视频</p>
          </div>

          <!-- 分页 -->
          <div class="paginationWrapper">
            <el-pagination
              background
              layout="slot, prev, next, jumper"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              :total="total"
              @current-change="handlePageChange"
            >
              <span class="pageInfo"
                >{{ currentPage }} / {{ totalPages || 1 }}</span
              >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频播放弹窗 -->
    <el-dialog
      :visible.sync="videoDialogVisible"
      :title="currentVideo.title"
      width="900px"
      custom-class="videoDialog"
      @close="closeVideoDialog"
    >
      <div class="videoPlayer">
        <video
          ref="videoPlayer"
          :src="currentVideo.url"
          controls
          autoplay
          style="width: 100%; height: 100%"
        ></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { supportVideo, DictionaryData } from "@/assets/API/service";
import define from "@/utils/define";
import Hls from "hls.js";
const baceUrl = define.APIURl;
export default {
  name: "VideoTutorial",
  props: {
    // 搜索结果跳转时待定位自动播放的视频id
    autoPlayId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchKeyword: "",
      loading: false,

      // 分页
      currentPage: 1,
      pageSize: 6,
      total: 0,

      // 视频数据
      allVideoList: [],

      // 树形分类数据
      categoryTreeData: [],
      treeProps: {
        children: "children",
        label: "fullName",
      },
  defaultExpandedKeys: [],
  currentNodeKey: null,
  currentTypeIds: [],
      currentCategory: null, // 当前选中的分类节点

      // 视频弹窗
      videoDialogVisible: false,
      currentVideo: {},
      autoPlayDone: false,
      language: this.$i18n.locale,
      currentHls: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
  },
  mounted() {
    this.fetchCategoryTree();
    this.fetchVideoList();
  },
  beforeDestroy() {
    if (this.currentHls) {
      this.currentHls.destroy();
      this.currentHls = null;
    }
  },
  methods: {
    // 获取分类树数据
    fetchCategoryTree() {
      DictionaryData().then((res) => {
        if (res && res.data) {
          this.categoryTreeData = res.data.list || [];
          // 默认展开所有层级节点
          this.defaultExpandedKeys = this.getAllExpandedKeys(
            this.categoryTreeData
          );
          // 默认不选中任何节点，右侧加载全部视频
          this.currentNodeKey = null;
          this.currentTypeIds = [];
          this.$nextTick(() => {
            this.$refs.categoryTree?.setCurrentKey(null);
          });
        }
        this.loading = false;
      });
    },

    // 获取视频列表
    fetchVideoList() {
      this.loading = true;
      supportVideo({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        typeId:
          this.currentTypeIds && this.currentTypeIds.length
            ? this.currentTypeIds.join(",")
            : null,
        keyword: this.searchKeyword || null,
      }).then((res) => {
        if (res.code == 200 && res.data.records) {
          this.loading = false;
          this.total = res.data.total || 0;
          this.allVideoList = res.data.records.map((item) => ({
            id: item.id,
            title: this.language == "zh" ? item.title : item.titleEn,
            url: item.videoUrl.includes("http")
              ? item.videoUrl
              : baceUrl + "/" + item.videoUrl,
            thumb: item.videoThumb
              ? (() => {
                  try {
                    const arr = JSON.parse(item.videoThumb);
                    return arr && arr.length ? baceUrl + arr[0].url : "";
                  } catch (e) {
                    return "";
                  }
                })()
              : "",
          }));
          this.tryAutoPlayFromSearch();
        }
      });
    },

    // 树节点点击
    handleNodeClick(data, node) {
      this.currentNodeKey = data.id;
      this.currentCategory = data;
      this.currentTypeIds = this.getAllChildIds(data);
      this.currentPage = 1;
      this.fetchVideoList();
    },

    // 获取所有需要展开的节点id
    getAllExpandedKeys(tree) {
      let ids = [];
      tree.forEach((node) => {
        ids.push(node.id);
        if (node.children && node.children.length > 0) {
          ids = ids.concat(this.getAllExpandedKeys(node.children));
        }
      });
      return ids;
    },

    // 获取节点及其所有子孙节点的 id 列表
    getAllChildIds(node) {
      let ids = [node.id];
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          ids = ids.concat(this.getAllChildIds(child));
        });
      }
      return ids;
    },

    // 在树中查找节点
    findNodeById(tree, id) {
      for (const node of tree) {
        if (node.id === id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodeById(node.children, id);
          if (found) return found;
        }
      }
      return null;
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.fetchVideoList();
    },

    // 分页
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchVideoList();
    },

    // 播放视频
    // 搜索结果跳转定位：列表加载后找到目标视频自动打开播放，当前页没有则继续翻页查找
    tryAutoPlayFromSearch() {
      if (!this.autoPlayId || this.autoPlayDone) return;
      const hit = this.allVideoList.find(
        (v) => String(v.id) === String(this.autoPlayId)
      );
      if (hit) {
        this.autoPlayDone = true;
        this.$emit("played");
        this.playVideo(hit);
        return;
      }
      if (this.currentPage * this.pageSize < this.total && this.currentPage < 50) {
        this.currentPage += 1;
        this.fetchVideoList();
      } else {
        // 全部页都没有（数据可能已下架），放弃定位
        this.autoPlayDone = true;
        this.$emit("played");
      }
    },

    playVideo(video) {
      this.currentVideo = video;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        this.initHlsPlayer();
      });
    },
    initHlsPlayer() {
      const video = this.$refs.videoPlayer;
      if (!video) return;

      const url = this.currentVideo.url;

      if (url.endsWith(".m3u8")) {
        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(url);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play();
          });

          this.currentHls = hls;
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = url;
          video.play();
        } else {
          this.$message.error("您的浏览器不支持播放该视频格式");
        }
      } else {
        video.src = url;
        video.play();
      }
    },

    // 关闭视频弹窗
    closeVideoDialog() {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
      if (this.currentHls) {
        this.currentHls.destroy();
        this.currentHls = null;
      }
      this.videoDialogVisible = false;
      this.currentVideo = {};
    },

    // 返回
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style scoped lang="scss">
.videoTutorialPage {
  background: #f7f8fb;
  min-height: 100vh;
}

/* 面包屑导航 */
.breadcrumbBar {
  background: #333;
  padding: 16px 0;

  .breadcrumbContent {
    width: 1200px;
    margin: 0 auto;
    font-size: 14px;
    color: #fff;

    .breadcrumbLink {
      color: #aaa;
      cursor: pointer;

      &:hover {
        color: #fff;
      }
    }

    .breadcrumbSeparator {
      margin: 0 8px;
      color: #666;
    }

    .breadcrumbCurrent {
      color: #fff;
    }
  }
}

/* 主容器 */
.videoContainer {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}

/* 搜索框 */
.searchBox {
  margin-bottom: 30px;

  ::v-deep .el-input {
    width: 300px;

    .el-input__inner {
      border-radius: 4px;
      border-color: #ddd;

      &:focus {
        border-color: #2b85e5;
      }
    }
  }
}

/* 主内容区 */
.mainContent {
  display: flex;
  gap: 40px;
}

/* 左侧分类导航 - 树形结构 */
.categoryNav {
  width: 200px;
  flex-shrink: 0;

  ::v-deep .el-tree {
    background: transparent;

    .el-tree-node {
      &:focus > .el-tree-node__content {
        background-color: transparent;
      }
    }

    .el-tree-node__content {
      height: 40px;
      padding-left: 0 !important;

      &:hover {
        background-color: transparent;

        .node-label {
          color: #2b85e5;
        }
      }
    }

    // 选中状态
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: transparent;

      .node-label {
        color: #2b85e5;
        font-weight: 500;
      }
    }

    // 展开箭头
    .el-tree-node__expand-icon {
      color: #999;
      font-size: 14px;
      padding: 6px;

      &.expanded {
        transform: rotate(90deg);
      }

      &.is-leaf {
        color: transparent;
      }
    }

    // 节点内容
    .custom-tree-node {
      display: flex;
      align-items: center;
      width: 100%;

      .node-label {
        font-size: 14px;
        color: #333;
        transition: color 0.3s;
      }
    }

    // 第一层节点样式（更粗的字体）
    & > .el-tree-node > .el-tree-node__content {
      .node-label {
        font-size: 16px;
        font-weight: 600;
      }
    }

    // 子节点缩进
    .el-tree-node__children {
      .el-tree-node__content {
        padding-left: 18px !important;
      }

      // 第三层及以下
      .el-tree-node__children {
        .el-tree-node__content {
          padding-left: 36px !important;
        }
      }
    }
  }
}

/* 右侧视频列表 */
.videoListWrapper {
  flex: 1;
  position: relative;
  min-height: 400px;
}

.videoGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  min-height: 400px;
}

.videoCard {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  height: 260px;
  border: 1px solid #eee;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transform: translateY(-4px);
  }

  .videoThumb {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }

  .videoThumbEmpty {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f2f5;
    i {
      font-size: 48px;
      color: #c0c4cc;
    }
  }

  .videoInfo {
    padding: 12px 16px;

    .videoTitle {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      line-height: 1.5;
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

/* 空状态 */
.emptyState {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  color: #999;
  z-index: 2;

  i {
    font-size: 64px;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
  }
}

/* 分页 */
.paginationWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;

  .pageInfo {
    font-size: 14px;
    color: #2b85e5;
    margin-right: 8px;
  }

  ::v-deep .el-pagination {
    padding: 0;

    .btn-prev,
    .btn-next {
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      min-width: 28px;
      height: 28px;

      &:hover:not(:disabled) {
        color: #2b85e5;
        border-color: #2b85e5;
      }

      &:disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }

    .el-pagination__jump {
      margin-left: 12px;
      font-size: 14px;
      color: #606266;

      .el-input {
        width: 50px;
        margin: 0 6px;

        .el-input__inner {
          height: 28px;
          line-height: 28px;
          text-align: center;
          border-color: #dcdfe6;

          &:focus {
            border-color: #2b85e5;
          }
        }
      }
    }
  }
}

/* 视频播放弹窗 */
::v-deep .videoDialog {
  pointer-events: all;
  .el-dialog__body {
    padding: 0;
  }

  .videoPlayer {
    width: 100%;
    height: 600px;
    background: #000;
  }
}
</style>
